import React, { Fragment } from "react";

import {
  UnblockDeviceDropdownItem,
  UnblockDeviceModalItem,
} from "../../../../../../components/devices/unblockDeviceItem";
import {
  RenameDeviceDropdownItem,
  RenameDeviceModalItem,
} from "../../../../../../components/devices/renameDeviceItem";
import { DeviceDropdownMenu } from "../../../../../../components/devices/DeviceDropdownMenu";
import { Mobile, NotMobile } from "../../../../../../hocs/Responsive";
import { DeviceActionsToggle } from "../../../../../../components/devices/DeviceActionsDialog";

export const BlockedDevicesActionsDropdown = ({ device }) => {
  const dropdownItems = [
    <UnblockDeviceDropdownItem device={device} />,
    <RenameDeviceDropdownItem device={device} />,
  ];

  const modalItems = [
    <UnblockDeviceModalItem device={device} />,
    <RenameDeviceModalItem device={device} />,
  ];

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle
          deviceName={device.name}
          menuItems={modalItems}
          ariaDeviceName={device.name}
        />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu
          menuItems={dropdownItems}
          deviceName={device.name}
        />
      </NotMobile>
    </Fragment>
  );
};
